var cov_m5qe7kvo1 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Node.tsx",
      hash = "08b2c65cda24cd53b467cae9d4b2860e806388c7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Node.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 77
        }
      },
      "1": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 16
        }
      },
      "2": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "3": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 50
        }
      },
      "4": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 52
        }
      },
      "5": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 60
        }
      },
      "6": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 52
        }
      },
      "7": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 51
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 63
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 65
        }
      },
      "11": {
        start: {
          line: 45,
          column: 26
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "13": {
        start: {
          line: 51,
          column: 93
        },
        end: {
          line: 51,
          column: 103
        }
      },
      "14": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "15": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 29
        }
      },
      "16": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 12
        }
      },
      "17": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "18": {
        start: {
          line: 56,
          column: 22
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "19": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "20": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 84
        }
      },
      "21": {
        start: {
          line: 58,
          column: 28
        },
        end: {
          line: 58,
          column: 84
        }
      },
      "22": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "23": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 38
        }
      },
      "24": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 22
        }
      },
      "25": {
        start: {
          line: 68,
          column: 45
        },
        end: {
          line: 68,
          column: 55
        }
      },
      "26": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 50
        }
      },
      "27": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 70,
          column: 50
        }
      },
      "28": {
        start: {
          line: 74,
          column: 36
        },
        end: {
          line: 74,
          column: 46
        }
      },
      "29": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 34
        }
      },
      "30": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 77
        }
      },
      "31": {
        start: {
          line: 76,
          column: 18
        },
        end: {
          line: 76,
          column: 77
        }
      },
      "32": {
        start: {
          line: 80,
          column: 26
        },
        end: {
          line: 80,
          column: 36
        }
      },
      "33": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 78
        }
      },
      "34": {
        start: {
          line: 81,
          column: 72
        },
        end: {
          line: 81,
          column: 78
        }
      },
      "35": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "36": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 37
        }
      },
      "37": {
        start: {
          line: 87,
          column: 45
        },
        end: {
          line: 87,
          column: 55
        }
      },
      "38": {
        start: {
          line: 88,
          column: 19
        },
        end: {
          line: 88,
          column: 90
        }
      },
      "39": {
        start: {
          line: 88,
          column: 77
        },
        end: {
          line: 88,
          column: 90
        }
      },
      "40": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 48
        }
      },
      "41": {
        start: {
          line: 93,
          column: 34
        },
        end: {
          line: 93,
          column: 44
        }
      },
      "42": {
        start: {
          line: 94,
          column: 21
        },
        end: {
          line: 94,
          column: 59
        }
      },
      "43": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 42
        }
      },
      "44": {
        start: {
          line: 99,
          column: 99
        },
        end: {
          line: 99,
          column: 109
        }
      },
      "45": {
        start: {
          line: 100,
          column: 24
        },
        end: {
          line: 100,
          column: 34
        }
      },
      "46": {
        start: {
          line: 101,
          column: 21
        },
        end: {
          line: 101,
          column: 41
        }
      },
      "47": {
        start: {
          line: 102,
          column: 21
        },
        end: {
          line: 102,
          column: 59
        }
      },
      "48": {
        start: {
          line: 103,
          column: 28
        },
        end: {
          line: 103,
          column: 32
        }
      },
      "49": {
        start: {
          line: 104,
          column: 24
        },
        end: {
          line: 104,
          column: 68
        }
      },
      "50": {
        start: {
          line: 105,
          column: 22
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "51": {
        start: {
          line: 113,
          column: 39
        },
        end: {
          line: 113,
          column: 41
        }
      },
      "52": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 10
        }
      },
      "53": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 121,
          column: 5
        }
      },
      "54": {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 119,
          column: 39
        }
      },
      "55": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 30
        }
      },
      "56": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      },
      "57": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 49
        }
      },
      "58": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 54
        }
      },
      "59": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 124,
          column: 54
        }
      },
      "60": {
        start: {
          line: 126,
          column: 18
        },
        end: {
          line: 126,
          column: 96
        }
      },
      "61": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 130,
          column: 5
        }
      },
      "62": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 35
        }
      },
      "63": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 147,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 38
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 18
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 29
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 21
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 41
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 30
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 29
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 86
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 88,
            column: 67
          },
          end: {
            line: 88,
            column: 68
          }
        },
        loc: {
          start: {
            line: 88,
            column: 77
          },
          end: {
            line: 88,
            column: 90
          }
        },
        line: 88
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        loc: {
          start: {
            line: 92,
            column: 20
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 92
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 11
          },
          end: {
            line: 148,
            column: 3
          }
        },
        line: 98
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 52
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 19
          }
        }, {
          start: {
            line: 52,
            column: 23
          },
          end: {
            line: 52,
            column: 39
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 56
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 56
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 84
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 84
          }
        }, {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 84
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 10
          },
          end: {
            line: 58,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 10
          },
          end: {
            line: 58,
            column: 18
          }
        }, {
          start: {
            line: 58,
            column: 22
          },
          end: {
            line: 58,
            column: 26
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 14
          }
        }, {
          start: {
            line: 61,
            column: 18
          },
          end: {
            line: 61,
            column: 37
          }
        }, {
          start: {
            line: 61,
            column: 41
          },
          end: {
            line: 61,
            column: 104
          }
        }],
        line: 61
      },
      "8": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 50
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 50
          }
        }],
        line: 70
      },
      "9": {
        loc: {
          start: {
            line: 75,
            column: 18
          },
          end: {
            line: 75,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 28
          },
          end: {
            line: 75,
            column: 29
          }
        }, {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 33
          }
        }],
        line: 75
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 77
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 77
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 78
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 78
          }
        }],
        line: 81
      },
      "12": {
        loc: {
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 54
          },
          end: {
            line: 88,
            column: 64
          }
        }, {
          start: {
            line: 88,
            column: 67
          },
          end: {
            line: 88,
            column: 90
          }
        }],
        line: 88
      },
      "13": {
        loc: {
          start: {
            line: 95,
            column: 11
          },
          end: {
            line: 95,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 11
          },
          end: {
            line: 95,
            column: 19
          }
        }, {
          start: {
            line: 95,
            column: 23
          },
          end: {
            line: 95,
            column: 42
          }
        }],
        line: 95
      },
      "14": {
        loc: {
          start: {
            line: 104,
            column: 24
          },
          end: {
            line: 104,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 24
          },
          end: {
            line: 104,
            column: 30
          }
        }, {
          start: {
            line: 104,
            column: 34
          },
          end: {
            line: 104,
            column: 42
          }
        }, {
          start: {
            line: 104,
            column: 46
          },
          end: {
            line: 104,
            column: 68
          }
        }],
        line: 104
      },
      "15": {
        loc: {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 12
          }
        }, {
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 24
          }
        }],
        line: 107
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 108,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 108,
            column: 14
          }
        }, {
          start: {
            line: 108,
            column: 18
          },
          end: {
            line: 108,
            column: 28
          }
        }],
        line: 108
      },
      "17": {
        loc: {
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 109,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 109,
            column: 17
          }
        }, {
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 109,
            column: 35
          }
        }],
        line: 109
      },
      "18": {
        loc: {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 110,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 110,
            column: 17
          }
        }, {
          start: {
            line: 110,
            column: 21
          },
          end: {
            line: 110,
            column: 38
          }
        }],
        line: 110
      },
      "19": {
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }, {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }],
        line: 118
      },
      "20": {
        loc: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 118,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 118,
            column: 17
          }
        }, {
          start: {
            line: 118,
            column: 22
          },
          end: {
            line: 118,
            column: 52
          }
        }, {
          start: {
            line: 118,
            column: 56
          },
          end: {
            line: 118,
            column: 68
          }
        }],
        line: 118
      },
      "21": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }],
        line: 122
      },
      "22": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 33
          }
        }, {
          start: {
            line: 122,
            column: 37
          },
          end: {
            line: 122,
            column: 67
          }
        }],
        line: 122
      },
      "23": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 54
          }
        }, {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 54
          }
        }],
        line: 124
      },
      "24": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }],
        line: 128
      },
      "25": {
        loc: {
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 128,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 128,
            column: 15
          }
        }, {
          start: {
            line: 128,
            column: 19
          },
          end: {
            line: 128,
            column: 50
          }
        }],
        line: 128
      },
      "26": {
        loc: {
          start: {
            line: 134,
            column: 9
          },
          end: {
            line: 141,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 9
          },
          end: {
            line: 134,
            column: 17
          }
        }, {
          start: {
            line: 134,
            column: 21
          },
          end: {
            line: 134,
            column: 55
          }
        }, {
          start: {
            line: 135,
            column: 10
          },
          end: {
            line: 140,
            column: 12
          }
        }],
        line: 134
      },
      "27": {
        loc: {
          start: {
            line: 134,
            column: 23
          },
          end: {
            line: 134,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 23
          },
          end: {
            line: 134,
            column: 34
          }
        }, {
          start: {
            line: 134,
            column: 38
          },
          end: {
            line: 134,
            column: 54
          }
        }],
        line: 134
      },
      "28": {
        loc: {
          start: {
            line: 144,
            column: 9
          },
          end: {
            line: 144,
            column: 113
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 9
          },
          end: {
            line: 144,
            column: 16
          }
        }, {
          start: {
            line: 144,
            column: 20
          },
          end: {
            line: 144,
            column: 42
          }
        }, {
          start: {
            line: 144,
            column: 46
          },
          end: {
            line: 144,
            column: 113
          }
        }],
        line: 144
      },
      "29": {
        loc: {
          start: {
            line: 145,
            column: 9
          },
          end: {
            line: 145,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 21
          }
        }, {
          start: {
            line: 145,
            column: 25
          },
          end: {
            line: 145,
            column: 36
          }
        }, {
          start: {
            line: 145,
            column: 41
          },
          end: {
            line: 145,
            column: 46
          }
        }],
        line: 145
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Node.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import Spin from '../Spin';
import { isRTL } from '../config';
import Caret from '../icons/Caret';
import Checkbox from '../Checkbox';
import { cascaderClass } from './styles';
import { PureComponent } from '../component';
import { CHANGE_TOPIC } from '../Datum/types';
import { getParent } from '../utils/dom/element';
import { checkinputClass } from '../Checkbox/styles';
import { getDirectionClass } from '../utils/classname';
var checkBoxStyle = (cov_m5qe7kvo1.s[0]++, {
  marginRight: 8,
  marginTop: -1,
  verticalAlign: 'top'
});

var Node =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Node, _PureComponent);

  var _super = _createSuper2(Node);

  function Node(props) {
    var _this;

    _classCallCheck(this, Node);

    cov_m5qe7kvo1.f[0]++;
    cov_m5qe7kvo1.s[1]++;
    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    cov_m5qe7kvo1.s[2]++;
    _this.state = {
      loading: false
    };
    cov_m5qe7kvo1.s[3]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_m5qe7kvo1.s[4]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_m5qe7kvo1.s[5]++;
    _this.handlePathChange = _this.handlePathChange.bind(_assertThisInitialized(_this));
    cov_m5qe7kvo1.s[6]++;
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    cov_m5qe7kvo1.s[7]++;
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    cov_m5qe7kvo1.s[8]++;

    _this.props.datum.subscribe(CHANGE_TOPIC, _this.handleUpdate);

    return _this;
  }

  _createClass(Node, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_m5qe7kvo1.f[1]++;
      cov_m5qe7kvo1.s[9]++;

      _get(_getPrototypeOf(Node.prototype), "componentWillUnmount", this).call(this);

      cov_m5qe7kvo1.s[10]++;
      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "checkDisabled",
    value: function checkDisabled() {
      cov_m5qe7kvo1.f[2]++;

      var _ref = (cov_m5qe7kvo1.s[11]++, this.props),
          datum = _ref.datum,
          id = _ref.id;

      cov_m5qe7kvo1.s[12]++;
      return datum.isDisabled(id);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_m5qe7kvo1.f[3]++;

      var _ref2 = (cov_m5qe7kvo1.s[13]++, this.props),
          id = _ref2.id,
          data = _ref2.data,
          path = _ref2.path,
          onChange = _ref2.onChange,
          onPathChange = _ref2.onPathChange,
          loader = _ref2.loader,
          multiple = _ref2.multiple,
          datum = _ref2.datum,
          shouldFinal = _ref2.shouldFinal;

      cov_m5qe7kvo1.s[14]++;

      if ((cov_m5qe7kvo1.b[1][0]++, shouldFinal) && (cov_m5qe7kvo1.b[1][1]++, this.hasChildren)) {
        cov_m5qe7kvo1.b[0][0]++;
        cov_m5qe7kvo1.s[15]++;
        this.handlePathChange();
        cov_m5qe7kvo1.s[16]++;
        return;
      } else {
        cov_m5qe7kvo1.b[0][1]++;
      }

      cov_m5qe7kvo1.s[17]++;

      if (onPathChange) {
        cov_m5qe7kvo1.b[2][0]++;
        cov_m5qe7kvo1.s[18]++;
        onPathChange(id, data, path, true);
      } else {
        cov_m5qe7kvo1.b[2][1]++;
      }

      cov_m5qe7kvo1.s[19]++;

      if (!multiple) {
        cov_m5qe7kvo1.b[3][0]++;
        cov_m5qe7kvo1.s[20]++;

        if ((cov_m5qe7kvo1.b[5][0]++, onChange) && (cov_m5qe7kvo1.b[5][1]++, path)) {
          cov_m5qe7kvo1.b[4][0]++;
          cov_m5qe7kvo1.s[21]++;
          onChange([].concat(_toConsumableArray(path), [id]), datum.getDataById(id));
        } else {
          cov_m5qe7kvo1.b[4][1]++;
        }
      } else {
        cov_m5qe7kvo1.b[3][1]++;
      }

      cov_m5qe7kvo1.s[22]++;

      if ((cov_m5qe7kvo1.b[7][0]++, loader) && (cov_m5qe7kvo1.b[7][1]++, !this.state.loading) && (cov_m5qe7kvo1.b[7][2]++, !getParent(e.target, ".".concat(checkinputClass('_'))))) {
        cov_m5qe7kvo1.b[6][0]++;
        cov_m5qe7kvo1.s[23]++;
        this.setState({
          loading: true
        });
        cov_m5qe7kvo1.s[24]++;
        loader(id, data);
      } else {
        cov_m5qe7kvo1.b[6][1]++;
      }
    }
  }, {
    key: "handlePathChange",
    value: function handlePathChange() {
      cov_m5qe7kvo1.f[4]++;

      var _ref3 = (cov_m5qe7kvo1.s[25]++, this.props),
          id = _ref3.id,
          data = _ref3.data,
          path = _ref3.path,
          onPathChange = _ref3.onPathChange; // if (active) return


      cov_m5qe7kvo1.s[26]++;

      if (onPathChange) {
        cov_m5qe7kvo1.b[8][0]++;
        cov_m5qe7kvo1.s[27]++;
        onPathChange(id, data, path);
      } else {
        cov_m5qe7kvo1.b[8][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked) {
      cov_m5qe7kvo1.f[5]++;

      var _ref4 = (cov_m5qe7kvo1.s[28]++, this.props),
          datum = _ref4.datum,
          id = _ref4.id,
          onChange = _ref4.onChange;

      cov_m5qe7kvo1.s[29]++;
      datum.set(id, checked ? (cov_m5qe7kvo1.b[9][0]++, 1) : (cov_m5qe7kvo1.b[9][1]++, 0));
      cov_m5qe7kvo1.s[30]++;

      if (onChange) {
        cov_m5qe7kvo1.b[10][0]++;
        cov_m5qe7kvo1.s[31]++;
        onChange(datum.getValue(), datum.getDataById(id));
      } else {
        cov_m5qe7kvo1.b[10][1]++;
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(e) {
      cov_m5qe7kvo1.f[6]++;

      var _ref5 = (cov_m5qe7kvo1.s[32]++, this.props),
          datum = _ref5.datum,
          id = _ref5.id;

      cov_m5qe7kvo1.s[33]++;

      if (getParent(e.target, ".".concat(checkinputClass('_')))) {
        cov_m5qe7kvo1.b[11][0]++;
        cov_m5qe7kvo1.s[34]++;
        return;
      } else {
        cov_m5qe7kvo1.b[11][1]++;
      }

      var checked = (cov_m5qe7kvo1.s[35]++, datum.getChecked(id));
      cov_m5qe7kvo1.s[36]++;
      this.handleChange(null, !checked);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      cov_m5qe7kvo1.f[7]++;

      var _ref6 = (cov_m5qe7kvo1.s[37]++, this.props),
          id = _ref6.id,
          active = _ref6.active,
          data = _ref6.data,
          renderItem = _ref6.renderItem;

      var render = (cov_m5qe7kvo1.s[38]++, typeof renderItem === 'function' ? (cov_m5qe7kvo1.b[12][0]++, renderItem) : (cov_m5qe7kvo1.b[12][1]++, function (d) {
        cov_m5qe7kvo1.f[8]++;
        cov_m5qe7kvo1.s[39]++;
        return d[renderItem];
      }));
      cov_m5qe7kvo1.s[40]++;
      return render(data, active, id);
    }
  }, {
    key: "render",
    value: function render() {
      cov_m5qe7kvo1.f[10]++;

      var _ref7 = (cov_m5qe7kvo1.s[44]++, this.props),
          active = _ref7.active,
          data = _ref7.data,
          multiple = _ref7.multiple,
          datum = _ref7.datum,
          id = _ref7.id,
          loader = _ref7.loader,
          expandTrigger = _ref7.expandTrigger,
          childrenKey = _ref7.childrenKey,
          shouldFinal = _ref7.shouldFinal;

      var _ref8 = (cov_m5qe7kvo1.s[45]++, this.state),
          loading = _ref8.loading;

      var disabled = (cov_m5qe7kvo1.s[46]++, this.checkDisabled());
      var children = (cov_m5qe7kvo1.s[47]++, data[childrenKey]);

      var _ref9 = (cov_m5qe7kvo1.s[48]++, this),
          hasChildren = _ref9.hasChildren;

      var mayChildren = (cov_m5qe7kvo1.s[49]++, (cov_m5qe7kvo1.b[14][0]++, loader) && (cov_m5qe7kvo1.b[14][1]++, !loading) && (cov_m5qe7kvo1.b[14][2]++, children === undefined));
      var className = (cov_m5qe7kvo1.s[50]++, cascaderClass('node', (cov_m5qe7kvo1.b[15][0]++, active) && (cov_m5qe7kvo1.b[15][1]++, 'active'), (cov_m5qe7kvo1.b[16][0]++, disabled) && (cov_m5qe7kvo1.b[16][1]++, 'disabled'), (cov_m5qe7kvo1.b[17][0]++, hasChildren) && (cov_m5qe7kvo1.b[17][1]++, 'has-children'), (cov_m5qe7kvo1.b[18][0]++, mayChildren) && (cov_m5qe7kvo1.b[18][1]++, 'may-be-children')));
      var style = (cov_m5qe7kvo1.s[51]++, {});
      var events = (cov_m5qe7kvo1.s[52]++, {});
      cov_m5qe7kvo1.s[53]++;

      if ((cov_m5qe7kvo1.b[20][0]++, !disabled) && ((cov_m5qe7kvo1.b[20][1]++, expandTrigger !== 'hover-only') || (cov_m5qe7kvo1.b[20][2]++, !hasChildren))) {
        cov_m5qe7kvo1.b[19][0]++;
        cov_m5qe7kvo1.s[54]++;
        events.onClick = this.handleClick;
        cov_m5qe7kvo1.s[55]++;
        style.cursor = 'pointer';
      } else {
        cov_m5qe7kvo1.b[19][1]++;
      }

      cov_m5qe7kvo1.s[56]++;

      if ((cov_m5qe7kvo1.b[22][0]++, expandTrigger === 'hover') || (cov_m5qe7kvo1.b[22][1]++, expandTrigger === 'hover-only')) {
        cov_m5qe7kvo1.b[21][0]++;
        cov_m5qe7kvo1.s[57]++;
        events.onMouseEnter = this.handlePathChange;
        cov_m5qe7kvo1.s[58]++;

        if (multiple) {
          cov_m5qe7kvo1.b[23][0]++;
          cov_m5qe7kvo1.s[59]++;
          events.onClick = this.handleSelect;
        } else {
          cov_m5qe7kvo1.b[23][1]++;
        }
      } else {
        cov_m5qe7kvo1.b[21][1]++;
      }

      var caret = (cov_m5qe7kvo1.s[60]++,
      /*#__PURE__*/
      React.createElement("span", {
        className: cascaderClass(getDirectionClass('caret')),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 19
        }
      },
      /*#__PURE__*/
      React.createElement(Caret, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 80
        }
      })));
      cov_m5qe7kvo1.s[61]++;

      if ((cov_m5qe7kvo1.b[25][0]++, isRTL()) && (cov_m5qe7kvo1.b[25][1]++, checkBoxStyle.marginRight !== 0)) {
        cov_m5qe7kvo1.b[24][0]++;
        cov_m5qe7kvo1.s[62]++;
        checkBoxStyle.marginRight = 0;
      } else {
        cov_m5qe7kvo1.b[24][1]++;
      }

      cov_m5qe7kvo1.s[63]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style
        }, events, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 133,
            columnNumber: 7
          }
        }), (cov_m5qe7kvo1.b[26][0]++, multiple) && (cov_m5qe7kvo1.b[26][1]++, !((cov_m5qe7kvo1.b[27][0]++, shouldFinal) && (cov_m5qe7kvo1.b[27][1]++, this.hasChildren))) && (cov_m5qe7kvo1.b[26][2]++,
        /*#__PURE__*/
        React.createElement(Checkbox, {
          checked: datum.getChecked(id),
          disabled: disabled,
          onChange: this.handleChange,
          style: checkBoxStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 135,
            columnNumber: 11
          }
        })), this.renderContent(), (cov_m5qe7kvo1.b[28][0]++, loading) && (cov_m5qe7kvo1.b[28][1]++, children === undefined) && (cov_m5qe7kvo1.b[28][2]++,
        /*#__PURE__*/
        React.createElement(Spin, {
          className: cascaderClass('loading'),
          size: 10,
          name: "ring",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 47
          }
        })), ((cov_m5qe7kvo1.b[29][0]++, hasChildren) || (cov_m5qe7kvo1.b[29][1]++, mayChildren)) && (cov_m5qe7kvo1.b[29][2]++, caret))
      );
    }
  }, {
    key: "hasChildren",
    get: function get() {
      cov_m5qe7kvo1.f[9]++;

      var _ref10 = (cov_m5qe7kvo1.s[41]++, this.props),
          data = _ref10.data,
          childrenKey = _ref10.childrenKey;

      var children = (cov_m5qe7kvo1.s[42]++, data[childrenKey]);
      cov_m5qe7kvo1.s[43]++;
      return (cov_m5qe7kvo1.b[13][0]++, children) && (cov_m5qe7kvo1.b[13][1]++, children.length > 0);
    }
  }]);

  return Node;
}(PureComponent);

export default Node;